<template>

    <div class="container-fluid">
        <div class="row">
            <div class="col-6">

            </div>
            <div class="col-6">
                <ol style="float: right;" class="breadcrumb ">
                    <li style="padding-left: 15px;" class="breadcrumb-item"><a href="/inicio">Início</a></li>
                    <li class="breadcrumb-item"><a >Exportar registros</a></li>
                </ol>
            </div>
        </div>

        <div id="pnconteudo">
             <div class="card mb-3">
                <div class="card-header">
                    <div class="row">
                        <div class="col-lg-2">
                            <div class="form-group">
                                <label for="edtipopesq">Tipo de documento</label>
                                <select class="form-select form-control" v-model="tipo"
                                    aria-label="Default select example">
                                    <option value="0">AFD</option>
                                    <option value="1">AEJ</option>
                                    <option value="2">AFDT (TXT)</option>
                                    <option value="3">Excel</option>
                                </select>
                            </div>
                        </div>

                        <div class="col-sm-4 col-md-4 col-lg-4">
                            <span class="lblselect2">Filial/Empresa:</span>
                            <select id="cbempresa" data-placeholder="Selecione uma opção" :disabled="ativadesativa" data-allow-clear="true"
                                style="width:100%;" v-model="idempresa">
                            </select>
                        </div>

                        <div class="col-lg-2">
                            <div class="form-group">
                                <label for="">Data Início</label>
                                <input type="date" v-model="datainicio" class="form-control">
                            </div>
                        </div>

                        <div class="col-lg-2">
                            <div class="form-group">
                                <label for="">Data Fim</label>
                                <input type="date" v-model="datafim" class="form-control">
                            </div>
                        </div>

                        <div class="col-lg-2" style="padding-top: 25px;">
                            <a @click.prevent="mtdgerararquivo()" style="width: 100%;" class="btn btn-info">
                                <i class="bi bi-file-earmark"></i> Gerar
                            </a>
                        </div>

                    </div>
                </div> 
            </div>

        </div>
    </div>


</template>

<script>

//Eu sou o caminho, a verdade e a vida. Ninguém vem ao Pai senão por mim. (João 14:6);

// @ is an alias to /src
import Swal from 'sweetalert2'
import util from '../util.js'
import EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
import router from '@/router/index.js';


import { ref } from "vue";

const onClickHandler = (page) => {
  console.log(page);
};

const pagina_atual = ref(1);



export default {
    name: 'exportardados',

    data() {
        return {
            tipo: 0,
            idempresa : null,
            datainicio: '',
            datafim   : '',

        }
    },
    components: {
        EasyDataTable,
      
    },

    methods: {
        mtdgerararquivo(){
            let vself = this;

            vself.$loading.show();
            let parametros = [
                { parametro: 'op',          valor: 'gerararquivo' },
                { parametro: 'idusuario',   valor: vself.$store.state.usuario.idusuario },
                { parametro: 'idempresa',   valor: vself.$store.state.usuario.idempresa },
                { parametro: 'datainicio',  valor: vself.datainicio },
                { parametro: 'datafim',     valor: vself.datafim },
                { parametro: 'idfilial',    valor: vself.idempresa },
                { parametro: 'tipo',        valor: vself.tipo },
         
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/exportarregistros.php');
            retorno.then(function (response) {
                
                vself.$loading.hide();
                if (response.data.sucesso) {
                    const linkSource = `data:${response.data.tipo};base64,${response.data.arquivo}`;
                    const downloadLink = document.createElement("a");
                    const fileName = response.data.nome;

                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                    
                    Swal.fire("Sucesso", "Arquivo gerado com sucesso!", "success");
                } else {
                    Swal.fire("Erro", response.data.mensagem, "error");
                }


            }).catch(function (response) {
               
                vself.$loading.hide();
            });
        }
    

    },
    computed:{
     
    },
    mounted() {

        let vself = this;

         $("#cbempresa").select2({
            id: function (e) { return e.id },
            ajax: {
                url: util.servidor+'/controller/select2sql.php',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        idempresa: vself.$store.state.usuario.idempresa,
                        sqlini: 'select id, nome from tbfiliais ',
                        sqlfim: '',
                        cpid: 'id',
                        cpdesc: 'nome'
                    };
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
                cache: true
            },
            minimumInputLength: 0,
            theme: 'bootstrap',
            language: "pt-BR",
            templateResult: util.formatResult,
            templateSelection: util.formatSelection
        }).change(function () {
            vself.idempresa = $("#cbempresa").val();
        });
    },
    watch:{
        pagina_atual(val){
            this.mtdcarregaitem(val)
        }
    }
}
</script>
<style>

.pagination-container {
    display: flex;

    column-gap: 10px;
  }

  .paginate-buttons {
  

    border-radius: 20px;

    display: flex;

    cursor: pointer;

    background-color: rgb(242, 242, 242);

    border: 1px solid rgb(217, 217, 217);

    font-size: small;

    color: black;
  }

  .paginate-buttons:hover {
    background-color: #d8d8d8;
  }

  .active-page {
    background-color: #393193;

    border: 1px solid #393193;

    color: white;
  }

  .active-page:hover {
    background-color: #393193;
  }

</style>